import {
  LOADER_STATUS,
  SAVE_DATA,
  SET_IS_EDIT,
  SAVE_REJECTED_DATA,
  PROFILE_INFO,
  PROFILE_DATA,
  SAVE_SAVED_DATA,
  SAVE_TRACK_RETURN,
  SAVE_VALIDATION_DATA,
  SAVE_PREVIEW_FETCH_DATA,
  SAVE_PREVIEW_COMPARATIVE_DATA,
  SAVE_HISTORY_DATA,
  SET_ENTITY_LIST,
  SET_IS_SAVE_TO_GSTIN_MODAL,
  SAVE_GSTIN_MODAL_LIST_DATA,
  SET_TOTAL_PAGES,
} from "./constants";
import { ToastContainer, toast } from "react-toastify";
import {
  saveLocalStorage,
  getToken,
  getLocalStorage,
} from "components/Helper/Helper";
import { Config } from "../../../Config.js";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import axios from "axios";
import { COMMON_MSGS } from "Constant/Messages";

export function loader(status) {
  return {
    type: LOADER_STATUS,
    loaderStatus: status,
  };
}
export function setIsEdit() {
  return {
    type: SET_IS_EDIT,
  };
}
export function setSaveToGstinModal() {
  return {
    type: SET_IS_SAVE_TO_GSTIN_MODAL,
  };
}

// export function getProgressData(val) {
//   return {
//     type: ON_PROGRESS_DATA,
//     progressData: val,
//   };
// }
// export function getSummaryData(val) {
//   return {
//     type: ON_GSTR_SUMMARY,
//     summaryData: val,
//   };
// }
// export function getSummaryAmdData(val) {
//   return {
//     type: ON_GSTR_SUMMARY_AMD,
//     summaryAmdData: val,
//   };
// }
// export function setHsnSummary(data) {
//   return {
//     type: SET_HSN_DATA,
//     hsnData: data,
//   };
// }
// export function setNilSummary(data) {
//   return {
//     type: SET_NIL_DATA,
//     nilData: data,
//   };
// }
// export function setDocIssueSummary(data) {
//   return {
//     type: SET_DOC_ISSUE_DATA,
//     docData: data,
//   };
// }

// export function setTotalRecord(count) {
//   return {
//     type: SET_TOTAL_RECORD,
//     totalRecord: count,
//   };
// }
async function errorNot(errMsgVal) {
  await toast.success(`${errMsgVal}`, {
    position: "bottom-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
}

/* Call an error Toaster with this method */
async function errorNotErr(errMsgVal) {
  toast.error(`${errMsgVal}`, {
    position: "bottom-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
}

export function saveData(payload) {
  return {
    type: SAVE_DATA,
    data: payload,
  };
}

export function saveRejectedData(payload) {
  return {
    type: SAVE_REJECTED_DATA,
    data: payload,
  };
}

export function saveSavedData(payload) {
  return {
    type: SAVE_SAVED_DATA,
    data: payload,
  };
}

export function profileInfo(payload) {
  return {
    type: PROFILE_DATA,
    profileData: payload,
  };
}

export function saveGstrreturnTrackSummary(payload) {
  return {
    type: SAVE_TRACK_RETURN,
    data: payload,
  };
}

export function saveGstnvalidationData(payload) {
  console.log(payload, "saveGstnvalidationData");
  return {
    type: SAVE_VALIDATION_DATA,
    data: payload,
  };
}
export function savePreviewFetchData(payload) {
  return {
    type: SAVE_PREVIEW_FETCH_DATA,
    data: payload,
  };
}
export function savePreviewComparativeData(payload) {
  return {
    type: SAVE_PREVIEW_COMPARATIVE_DATA,
    data: payload,
  };
}
export function saveHistoryTableData(payload) {
  return {
    type: SAVE_HISTORY_DATA,
    data: payload,
  };
}
export function setSaveToGstinModalList(payload) {
  return {
    type: SAVE_GSTIN_MODAL_LIST_DATA,
    data: payload,
  };
}

export function setEntityList(data){
  return {
    type: SET_ENTITY_LIST,
    payload: data,
  };
}
export function totalPages(pages){
  return {
    type: SET_TOTAL_PAGES,
    payload: pages,
  };
}

export function clearData(){
  return (dispatch) => {
    dispatch(saveRejectedData([]));
    dispatch(saveSavedData([]));
    dispatch(savePreviewFetchData([]));
    dispatch(savePreviewComparativeData([]));
    dispatch(saveHistoryTableData([]));
  }
}

// export function setAutoPopulatedHistory(payload) {
//   return {
//     type: SET_AUTO_POPULATED_HISTORY,
//     payload: payload,
//   };
// }

// export function setRecoHistory(payload) {
//   return {
//     type: SET_RECO_HISTORY,
//     payload: payload,
//   };
// }

/* Get an list of GSTIN with the help of this method. */
export const getEntityGSTINData = (value) => {
  console.log(value);
  return (dispatch) => {
    dispatch(loader(true));
    let data = {
      profileId: value,
    };
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}gst/get_profile`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      })
        .then((response) => {
          if (response.data.error != 1) {
            const sortedGstin = response.data.profileInfo.sort((a, b) =>
              a.gstin > b.gstin ? 1 : -1
            );
            dispatch(profileInfo(sortedGstin));
          }

          dispatch(loader(false));
          resolve(true);
        })
        .catch((error) => {
          dispatch(loader(false));
          console.log(error);
          reject(true);
        });
    });
  };
};

/* Get an list of GSTIN with the help of this method. */
export const getGstinByEntity = (value) => {
  console.log(value);
  return (dispatch) => {
    dispatch(loader(true));
    let data = {
      entity_id: value,
      user_id:getLocalStorage("user_id").user_id

    };
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}console/getGstnListByEntityId`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      })
        .then((response) => {
          if (response.data.error != 1) {


            if(response.data?.data?.length > 0){
              console.log(response.data?.data,"data in console")
                const sortedGstin = response.data.data.sort((a, b) =>
                a.gstin > b.gstin ? 1 : -1
                );
                dispatch(profileInfo(sortedGstin));
            }else{
              dispatch(profileInfo([]));
            }
          }

          dispatch(loader(false));
          resolve(true);
        })
        .catch((error) => {
          dispatch(loader(false));
          console.log(error);
          reject(true);
        });
    });
  };
};

export const fetchRejectedData = (entity, gstin, ret_period) => {
  return (dispatch) => {
    const data = {
      entity,
      gstn: gstin,
      ret_period: ret_period,
    };
    dispatch(loader(true));
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}gstR7/fetchRejectedData`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      })
        .then((response) => {
          if (response?.data?.error != 1) {
            dispatch(saveRejectedData(response.data.data));
            errorNot(response.data.message);
          }else{
            errorNotErr(response.data.message);
          }
          dispatch(loader(false));
          resolve(true);
        })
        .catch((error) => {
          dispatch(loader(false));
          console.log(error);
          reject(true);
        });
    });
  };
};
// export const fetchSavedData = (entity, gstin, ret_period) => {
export const fetchRejectedDataOnSubmit = (entity, gstin, ret_period) => {
  return (dispatch) => {
    const data = {
      entity,
      gstn: gstin,
      ret_period: ret_period,
    };
    dispatch(loader(true));
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}gstR7/fetchlocalrejecteddata`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      })
        .then((response) => {
          if (response?.data?.error != 1) {
            dispatch(saveRejectedData(response.data.data));
            errorNot(response.data.message);

          }else{
            errorNotErr(response.data.message);

          }
          dispatch(loader(false));
          resolve(true);
        })
        .catch((error) => {
          dispatch(loader(false));
          console.log(error);
          reject(true);
        });
    });
  };
};
export const fetchSavedData = (entity, gstin, ret_period, isSavedToGstin) => {
  return (dispatch) => {
    const data = {
      entity,
      gstn: gstin,
      ret_period: ret_period,
      isSavedToGstin:isSavedToGstin
    };
    dispatch(loader(true));
    dispatch(saveSavedData([]));
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}gstR7/getSavedata`,

        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      })
        .then((response) => {
          if (response.data.error != 1) {
            console.log(response.data.data, "responsedata");
            dispatch(saveSavedData(response.data.savedDataDao));
           // errorNot(response.data.message);
          } else{
            errorNotErr(response.data.message);
          }
          dispatch(loader(false));
          resolve(response.data);
        })
        .catch((error) => {
          dispatch(loader(false));
          console.log(error);
          reject(true);
        });
    });
  };
};

export const updateRejectedData = (json_data) => {
  return (dispatch) => {
    const data = {
      data_json: json_data,
    };
    dispatch(loader(true));
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}gstR7/updateRejectedData`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      })
        .then((response) => {
          if (response.data.error != 1) {
            // dispatch(fetchRejectedData());
            errorNot(response.data.message);
          }else{
            errorNotErr(response.data.message);
          }

          dispatch(loader(false));
          resolve(true);
        })
        .catch((error) => {
          dispatch(loader(false));
          console.log(error);
          reject(true);
        });
    });
  };
};

export const getGstrTrackSummay = (gstin, fy, isRefresh=false) => {
  return (dispatch) => {
    console.log(gstin, "gstin", "fyear", fy);
    if(fy == ""){
      dispatch(saveGstrreturnTrackSummary([]));
    }
    else{
    const data = {
      gstin,
      fy,
      isRefresh,
    };
    dispatch(saveGstrreturnTrackSummary([]));
    dispatch(loader(true));
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}gstrdatafetch/getGstrReturnSummary`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      })
        .then((response) => {
          if (response.data.error != 1) {
            dispatch(saveGstrreturnTrackSummary(response.data.data));
          }

          dispatch(loader(false));
          resolve(response.data);
        })
        .catch((error) => {
          dispatch(loader(false));
          console.log(error);
          reject(true);
        });
    });
  }
  };
};

export const getGstnValidationSummay = (gstin, isRefresh=false) => {

  return (dispatch) => {
    const data = {
      gstin,
      isRefresh,
    };
    dispatch(loader(true));
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}validateGstn/fetchSingleGstin`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      })
        .then((response) => {
          if (response.data.error != 1) {
            dispatch(saveGstnvalidationData(response.data.data));
          }

          dispatch(loader(false));
          resolve(response.data);
        })
        .catch((error) => {
          dispatch(loader(false));
          console.log(error);
          reject(true);
        });
    });
  };
};

export const fetchPreviewData = (entity, gstn, ret_period) => {
  return (dispatch) => {
    const data = {
      entity,
      gstn,
      ret_period,
    };
    dispatch(loader(true));
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}gstR7/getPerviewData`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      })
        .then((response) => {
          if (response.data.error != 1) {
            dispatch(savePreviewFetchData(response.data.data));
            // resolve(response.data.data);
            errorNot(response.data.message);
          }else{
            errorNotErr(response.data.message);
          }
          resolve(true);
          dispatch(loader(false));
        })
        .catch((error) => {
          dispatch(loader(false));
          console.log(error);
          reject(true);
        });
    });
  };
};
export const fetchPreviewSubmitData = (entity, gstn, ret_period) => {
  return (dispatch) => {
    const data = {
      entity,
      gstn,
      ret_period,
    };
    dispatch(loader(true));
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}gstR7/getPerviewData`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      })
        .then((response) => {
          if (response.data.error != 1) {
            dispatch(savePreviewFetchData(response.data.data));
            // resolve(response.data.data);
            errorNot(response.data.message);
          } else{
            errorNotErr(response.data.message);
          }
          resolve(true);
          dispatch(loader(false));
        })
        .catch((error) => {
          dispatch(loader(false));
          console.log(error);
          reject(true);
        });
    });
  };
};
export const fetchPreviewComparativeData = (entity, gstn, ret_period) => {
  return (dispatch) => {
    const data = {
      entity,
      gstn,
      ret_period,
    };
    dispatch(loader(true));
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}gstR7/getCompartivePerviewData`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      })
        .then((response) => {
          if (response.data.error != 1) {
            dispatch(savePreviewComparativeData(response.data.data));
            errorNot(response.data.message);
          } else{
            errorNotErr(response.data.message);
          }
          dispatch(loader(false));
          resolve(true);
        })
        .catch((error) => {
          dispatch(loader(false));
          console.log(error);
          reject(true);
        });
    });
  };
};
export const fetchHistoryData = (page=1, limit=30) => {
  return (dispatch) => {
    const data = {
      page,
      limit
    };
    dispatch(loader(true));
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}gstR7/getGstr7fetchhistory`,
        // data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      })
        .then((response) => {
          if (response.data.error != 1) {
            dispatch(saveHistoryTableData(response.data.data));
            dispatch(totalPages(response.data.data[0]?.total_records / limit));
            errorNot(response.data.message);
          } else{
            errorNotErr(response.data.message);
          }
          dispatch(loader(false));
          resolve(true);
        })
        .catch((error) => {
          dispatch(loader(false));
          console.log(error);
          reject(true);
        });
    });
  };
};
export const downloadRejectedData = (gstin, ret_period, entity, tableData) => {
  return (dispatch) => {
    dispatch(loader(true));
    let data={
      gstin,
      ret_period,
      entity,
      tableData,
    }
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        data,
        url: `${Config.url}gstR7/downloadRejectedData`,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
        responseType: "blob",
      })
        .then((response) => {
          // if (response.data.error != 1) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "GSTR7_Rejected_Data.xlsx");
          document.body.appendChild(link);
          link.click();
            // dispatch(saveRejectedTableData(response.data.data));
          // }

          dispatch(loader(false));
          errorNot(COMMON_MSGS.DATA_DOWNLOADED);
          resolve(true);
        })
        .catch((error) => {
          dispatch(loader(false));
          console.log(error);
          reject(true);
        });
    });
  };
};
export const downloadSavedData = (gstin, ret_period, tableData) => {
  return (dispatch) => {
    dispatch(loader(true));
    let data={
      gstin,
      ret_period,
      tableData
    }
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        data,
        url: `${Config.url}gstR7/downloadsavedData`,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
        responseType: "blob",
      })
        .then((response) => {
          // if (response.data.error != 1) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "GSTR7_Saved_Data.xlsx");
          document.body.appendChild(link);
          link.click();
            // dispatch(saveRejectedTableData(response.data.data));
          // }
          errorNot(COMMON_MSGS.DATA_DOWNLOADED);
          dispatch(loader(false));
          resolve(true);
        })
        .catch((error) => {
          dispatch(loader(false));
          console.log(error);
          reject(true);
        });
    });
  };
};
export const downloadPreviewComparativeData = (gstin, ret_period, tableData) => {
  return (dispatch) => {
    dispatch(loader(true));
    let data={
      gstin,
      ret_period,
      tableData
    }
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        data,
        url: `${Config.url}gstR7/downloadperviewData`,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
        responseType: "blob",
      })
        .then((response) => {
          // if (response.data.error != 1) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "GSTR7_Preview_Comparative_Data.xlsx");
          document.body.appendChild(link);
          link.click();
            // dispatch(saveRejectedTableData(response.data.data));
          // }
          errorNot(COMMON_MSGS.DATA_DOWNLOADED);
          dispatch(loader(false));
          resolve(true);
        })
        .catch((error) => {
          dispatch(loader(false));
          console.log(error);
          reject(true);
        });
    });
  };
};
export const downloadPreviewFetchData = (id, tableData) => {
  return (dispatch) => {
    dispatch(loader(true));
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        data:{id,tableData},
        url: `${Config.url}gstR7/downloadhistorygstr7Data`,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
        responseType: "blob",
      })
        .then((response) => {
          // if (response.data.error != 1) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "GSTR7_Preview_Fetch_Data.xlsx");
          document.body.appendChild(link);
          link.click();
            // dispatch(saveRejectedTableData(response.data.data));
          // }
          errorNot(COMMON_MSGS.DATA_DOWNLOADED);
          dispatch(loader(false));
          resolve(true);
        })
        .catch((error) => {
          dispatch(loader(false));
          console.log(error);
          reject(true);
        });
    });
  };
};
export const downloadHistoryData = (id, tableData) => {
  return (dispatch) => {
    dispatch(loader(true));
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        data:{id, tableData},
        url: `${Config.url}gstR7/downloadhistorygstr7Data`,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
        responseType: "blob",
      })
        .then((response) => {
          // if (response.data.error != 1) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "GSTR7_History_Data.xlsx");
          document.body.appendChild(link);
          link.click();
            // dispatch(saveRejectedTableData(response.data.data));
          // }
          errorNot(COMMON_MSGS.DATA_DOWNLOADED);
          dispatch(loader(false));
          resolve(true);
        })
        .catch((error) => {
          dispatch(loader(false));
          console.log(error);
          reject(true);
        });
    });
  };
};

export function getDeducteeGSTINData(gstin, period, type){
  return (dispatch) => {
    dispatch(loader(true));
    let data = {
      gstin,
      period,
      type,
    };
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}gstR7/deducteeGstinDetails`,
        data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      })
        .then((response) => {
          if (response.data.error != 1) {
            resolve(response.data.data);
          }else{
            resolve([]);
          }
          dispatch(loader(false));
        })
        .catch((error) => {
          dispatch(loader(false));
          console.log(error);
          reject(true);
        });
    });
  }
}

export function getEntityList(){
  return (dispatch) => {
    dispatch(loader(true));
    let data = {
      user_id:getLocalStorage("user_id").user_id
    };
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}console/getCompanyByUserId`,
        data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      })
        .then((response) => {
          if (response.data.error != 1) {
            let entityList = response.data.data.map((entity)=>{
              return {value:entity.company_id, label:entity.name}
            });
            dispatch(setEntityList(entityList));
            console.log("res data entity lis",response.data)
            resolve(true);
          }else{
            resolve([]);
          }
          dispatch(loader(false));
        })
        .catch((error) => {
          dispatch(loader(false));
          console.log(error);
          reject(true);
        });
    });
  }
}

export function saveToGstn(gstin, period){
  return (dispatch) => {
    dispatch(loader(true));
    let data = {
      gstn:gstin,
     ret_period: period
    };
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}gstR7/retsave`,
        data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      })
        .then((response) => {
          if (response.data.error != 1) {
           // console.log(response,"response in savetogstn")
           // errorNot(response.data.message);
            resolve(response.data);
          }else{
           errorNotErr(response.data.message);
            resolve([]);
          }
          dispatch(loader(false));
        })
        .catch((error) => {
          dispatch(loader(false));
          console.log(error);
          reject(true);
        });
    });
  }
}


export function getGstr7otpEvcRequest(gstin, period){
  return (dispatch) => {
   // dispatch(loader(true));
    let data = {
      gstn:gstin,
     ret_period: period
    };
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}gstR7/getGstr7otpEvcRequest`,
        data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      })
        .then((response) => {
          if (response.data.error != 1) {
            console.log(response,"response in savetogstn")
            resolve(response.data.data);
          }else{
            resolve([]);
          }
        //  dispatch(loader(false));
        })
        .catch((error) => {
         // dispatch(loader(false));
          console.log(error);
          reject(true);
        });
    });
  }
}